import styled from '@emotion/styled';

export const MainBlock = styled.div`
  font-family: 'SF Pro Text', serif;
  font-weight: 700;
  font-size: 25px;
  line-height: 100%;
`;
